import { getApi, gql } from '@wetransfer/transfer/apollo-api/src';
import {
  TransferAPIType,
  ReceivedTransfersQueryVariables,
} from '@wetransfer/transfer/apollo-api/usage/types';
import { User } from '@wetransfer/transfer/types/graphql-types';

import { transformTransferEdges } from './helpers';

export const GET_RECEIVED_TRANSFERS = gql`
  query getReceivedTransfers(
    $limit: Int
    $teamId: ID!
    $order: ReceivedTransfersOrder
    $page: Int
    $searchTerm: String
    $highlight: Boolean
  ) {
    currentUser {
      team(teamId: $teamId) {
        storageFull
        storageUsed
        receivedTransfers(
          limit: $limit
          order: $order
          page: $page
          searchTerm: $searchTerm
          highlight: $highlight
        ) {
          totalCount
          collection {
            createdAt
            downloadCount
            expiresAt
            files {
              totalCount
              collection {
                id
                name
                size
                type
              }
            }
            from
            id
            message
            name
            passwordProtected
            recipients {
              collection {
                downloaded
                email
              }
            }
            paid
            product {
              price {
                amount
                currency
              }
            }
            securityHash
            sender {
              avatarUrl
              email
              givenName
            }
            shortenedUrl
            state
            totalFileSize
            uploadedAt
          }
        }
      }
    }
  }
`;

export const getReceivedTransfers = async (
  variables: ReceivedTransfersQueryVariables
): Promise<{
  transfers: TransferAPIType[];
  storageFull: boolean;
}> => {
  const api = getApi();
  let currentUser: User;

  try {
    ({
      data: { currentUser },
    } = await api.query({
      query: GET_RECEIVED_TRANSFERS,
      variables,
    }));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  if (currentUser === null || currentUser === undefined) {
    throw new Error('No transfer data returned');
  }

  return {
    transfers: transformTransferEdges(currentUser.team.receivedTransfers),
    storageFull: currentUser.team.storageFull,
  };
};
